export default "__VITE_ASSET__d9KC0aGk__"